// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__J2DE5","label":"styles_label__2XPOo"};